var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecklist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "#ff0000",
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-9.96426,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.07742,0,0,1.06036,-6.74507,-10.2707)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.862,
    y: 14.911,
    width: 63.611,
    height: 83.858,
    style: {
      fill: "none",
      strokeWidth: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.6575,0,0,0.700002,6.90338,8.87088)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.754,
    y: 16.051,
    width: 56.493,
    height: 1.412,
    style: {
      fill: "none",
      strokeWidth: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.6575,0,0,0.700002,6.90338,29.2081)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.754,
    y: 16.051,
    width: 56.493,
    height: 1.412,
    style: {
      fill: "none",
      strokeWidth: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.6575,0,0,0.700002,6.90338,49.5454)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.754,
    y: 16.051,
    width: 56.493,
    height: 1.412,
    style: {
      fill: "none",
      strokeWidth: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.6575,0,0,0.700002,6.90338,69.8827)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.754,
    y: 16.051,
    width: 56.493,
    height: 1.412,
    style: {
      fill: "none",
      strokeWidth: 3
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.14182,0.524521,-0.461377,1.00436,88.6305,-15.9313)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,-1.22465e-16,1.22465e-16,-1,56.7228,168.258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.426,77.067L50,87.483L38.853,87.483L44.426,77.067Z",
    style: {
      fill: "none",
      strokeWidth: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0.407252)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.723,
    y: 23.329,
    width: 11.147,
    height: 57.446,
    style: {
      fill: "white",
      strokeWidth: 3
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.805394,0.0591973,-0.113531,1.54461,-22.8622,-33.233)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.086,
    y: 75.984,
    width: 2.869,
    height: 1.805
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M13.717,88.536L10.876,88.536L6.723,80.775L17.87,80.775L13.717,88.536Z",
    style: {
      fill: "white",
      strokeWidth: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.797459,0,0,0.797459,14.7157,26.6667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.91,20.852L57.559,25.5L65.904,13.483",
    style: {
      fill: "none",
      strokeWidth: "2.51px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.797459,0,0,0.797459,14.7157,5.55135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.91,20.852L57.559,25.5L65.904,13.483",
    style: {
      fill: "none",
      strokeWidth: "2.51px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/checklist.3aeaa272913e091a8d734cb32131126b.svg";
export { ForwardRef as ReactComponent };